export default __webpack_public_path__ + "static/media/delete.c6ac7ac4.svg";